// Check if user has visited before
if (!sessionStorage.getItem('hasVisited')) {
    // Mark as visited
    sessionStorage.setItem('hasVisited', 'true');
    
    // Prevent scrolling during animation
    document.documentElement.classList.add('no-scroll');
    
    // Remove animation wrapper after fade out completes
    setTimeout(() => {
        const wrapper = document.querySelector('.intro_animation-wrapper');
        if (wrapper) {
            wrapper.remove();
        }
        // Re-enable scrolling
        document.documentElement.classList.remove('no-scroll');
    }, 6000); // 5s delay + 1s fade out
} else {
    // Remove animation immediately if returning user
    const wrapper = document.querySelector('.intro_animation-wrapper');
    if (wrapper) {
        wrapper.remove();
    }
}